import {
  DataBlockUiEditor,
  DataBlockUiEditorProps,
} from '@lmt/unicorn-shared/app/components/measurements/DataBlockUiEditor';
import clsx from 'clsx';
import React, { FC, useCallback, useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '../common/ui-kit/buttons/Button';
import { FormComponentProps } from '../global-forms/GlobalForms.types';

import styles from '@lmt/unicorn-shared/app/components/global-forms/Content.module.scss';
import localStyles from './DataBlockView.module.scss';
import { useEventCallback } from '@mui/material';

export type CreateDataBlockProps = FormComponentProps & {
  dataBlockTypeId: number;
  patientId: number;
  caseId: number;
  visitId?: number;
};

export const CreateDataBlock: FC<CreateDataBlockProps> = (props) => {
  const { formType, formId, tryCompleteForm, registerFormDirtyStateRetriever } =
    props;
  const i18next = useTranslation();
  const hasUnsavedChangesRef = useRef(false);

  useEffect(() => {
    registerFormDirtyStateRetriever(formId, () => hasUnsavedChangesRef.current);
  }, []);
  const setHasUnsavedChanges = useEventCallback((value: boolean) => {
    hasUnsavedChangesRef.current = value;
  });

  const actions: DataBlockUiEditorProps['actions'] = useRef(null);

  const saveDataBlock = useCallback(async () => {
    await tryCompleteForm(
      formType,
      formId,
      async () => {
        await actions.current?.save();
      },
      i18next.t('data_blocks.loading'),
    ).catch((e) => console.log(e));
  }, [actions]);

  return (
    <div
      className={clsx(styles.autoSizedContainer, localStyles.container)}
      data-test-id="createDataBlockPopup"
    >
      <div className={styles.dataContainer}>
        <DataBlockUiEditor
          dataBlockTypeId={props.dataBlockTypeId}
          type={'create'}
          isEditable={true}
          actions={actions}
          caseId={props.caseId}
          visitId={props.visitId}
          patientId={props.patientId}
          setUnsavedChanges={setHasUnsavedChanges}
        />
      </div>
      <div className={styles.submitContainer}>
        <Button
          onClick={saveDataBlock}
          title={i18next.t('data_blocks.save_button')}
          className={styles.submit}
        />
      </div>
    </div>
  );
};
export default CreateDataBlock;
